import Button from "Components/button";
import { TEXT_WIDGET_SIZES, TextWidget } from "Components/optionForm";
import { themeVariables } from "Components/theme";
import { Popover } from "Components/withPopover";
import flatMap from "lodash/flatMap";
import size from "lodash/size";
import values from "lodash/values";
import React, { useCallback, useEffect, useMemo, useRef } from "react";
import { NEW_SCRIPT } from "../../constants";
import MethodsSubMenu from "../methodsSubMenu";
import locale from "./methodsBottomPanel.locale";
const selectedMethodsInputAttr = { class: "no-pointer-events" };
const methodsBottomPanelId = "methods_sidebar_bottom_panel";
const position = {
    my: "left bottom",
    at: "right bottom",
    of: `#${methodsBottomPanelId}`,
    offset: {
        x: 0,
        y: 0
    }
};
export default function MethodsBottomPanel(props) {
    const popoverRef = useRef(null);
    useEffect(() => {
        props.onInitialized && props.onInitialized();
        return () => {
            props.onSetShowScriptEditorPanel && props.onSetShowScriptEditorPanel(false);
        };
    }, []);
    useEffect(() => {
        !props.menuExpanded &&
            props.onSetShowScriptEditorPanel &&
            props.onSetShowScriptEditorPanel(false);
    }, [props.menuExpanded]);
    const handleHideSubMenu = useCallback(() => {
        var _a;
        if ((_a = popoverRef.current) === null || _a === void 0 ? void 0 : _a.instance) {
            props.onSetShowScriptEditorPanel && props.onSetShowScriptEditorPanel(false);
            popoverRef.current.instance.hide();
        }
    }, []);
    const handleStartMethods = useCallback(() => {
        props.activeDocumentId &&
            props.onRunMethods &&
            props.onRunMethods(props.activeDocumentId, values(props.selectedMethods));
    }, [props.onRunMethods, props.activeDocumentId, props.selectedMethods]);
    const handleOpenCreateScriptPanel = useCallback((methods, targetSelector) => {
        props.onSetShowScriptEditorPanel &&
            props.onSetShowScriptEditorPanel(true, { ...NEW_SCRIPT, Methods: methods }, targetSelector);
    }, [props.onSetShowScriptEditorPanel]);
    const settingsButton = useMemo(() => [
        {
            location: "after",
            name: "settings-button",
            options: {
                icon: "icon-cog-filled text-light-on-surface-variant icon-color-inherit font-bold font-h5",
                elementAttr: {
                    class: "no-border bg-transparent p-0"
                },
                width: TEXT_WIDGET_SIZES.BUTTON_WIDTH,
                height: TEXT_WIDGET_SIZES.BUTTON_HEIGHT,
                onClick: () => {
                    var _a;
                    if ((_a = popoverRef.current) === null || _a === void 0 ? void 0 : _a.instance) {
                        const { instance } = popoverRef.current;
                        instance.toggle(!instance.option("visible"));
                    }
                }
            }
        }
    ], []);
    const hasSelectedMethods = size(props.selectedMethods) !== 0;
    return hasSelectedMethods ? (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "pl-0_75 pr-0_75 pb-1", id: methodsBottomPanelId },
            React.createElement(TextWidget, { buttons: settingsButton, inputAttr: selectedMethodsInputAttr, stylingMode: "filled", value: locale.buildSelected(size(props.selectedMethods), size(flatMap(props.selectedMethods, "nodesSource"))) }),
            React.createElement(Button, { className: "btn-primary w-100 mt-1", text: locale.START_METHODS, onClick: handleStartMethods })),
        props.menuExpanded && (React.createElement(Popover, { popoverRef: popoverRef, position: position, showEvent: "none", popoverHeight: props.menuExpandedHeight, popoverClassName: "no-border p-0 no-popover-arrow", popoverContent: React.createElement(MethodsSubMenu, { height: "100%", onHide: handleHideSubMenu, selectedMethods: props.selectedMethods, onSetMethodSelected: props.onSetMethodSelected, onClear: props.onClear, documentObjects: props.documentObjects, onOpenCreateScriptPanel: handleOpenCreateScriptPanel }), zIndex: parseInt(themeVariables["zindex-devextreme-dx-menu-base"]) + 3 })))) : null;
}
